export const USER_MANAGEMENT_STALE_TIME = 60 * 60 * 1000; // 1 hour
